import { render, staticRenderFns } from "./badgeTracker.vue?vue&type=template&id=da45af4a&scoped=true&"
import script from "./badgeTracker.vue?vue&type=script&lang=js&"
export * from "./badgeTracker.vue?vue&type=script&lang=js&"
import style0 from "./badgeTracker.vue?vue&type=style&index=0&id=da45af4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da45af4a",
  null
  
)

export default component.exports